import React, { useState, useRef } from "react"

import { Modal } from "@tenforce/toolbox-modal-react"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { ColorName } from "@tenforce/toolbox-default-style"

import { GlobalState } from "../../../../store"
import { useAppSelector } from "../../../../hooks"

import { IRootCauseAnalysisActions } from "../.."

export interface Props {
    actions: IRootCauseAnalysisActions
}

export default function ControlsContextMenu({ actions }: Props): JSX.Element {
    const targetRef = useRef<HTMLButtonElement>(null)
    const [isVisible, setIsVisible] = useState(false)
    const { labels, findings } = useAppSelector(
        (state: GlobalState) => state.incidents,
    )

    const canStartOver = findings.length > 0

    // CONTEXT MENU VISIBILITY
    // if no actions are allowed then we should not show the context menu either
    if (!canStartOver) {
        return <></>
    }

    const buttonAlignmentClasses = "tw-px-4 tw-py-2"

    const hideModal = (): void => {
        setIsVisible(false)
    }

    return (
        <>
            <Action
                data-ft-component="showControlsContextMenu"
                actionType={ActionType.button}
                isTransparent={true}
                textColor={ColorName.Goldenrod}
                onClick={(): void => {
                    setIsVisible(true)
                }}
                ref={targetRef}
                title={labels.contextMenu}
            >
                {Symbols.EllipsisVertical}
            </Action>
            <Modal
                isShown={isVisible}
                containerProps={{
                    targetRef,
                    id: "rcaControlsContextMenu",
                    onClose: hideModal,
                }}
                innerContentProps={{
                    extraClasses: "bg-white",
                }}
            >
                <div className="tw-flex tw-flex-col tw-py-2 tw-gap-2">
                    <Action
                        actionType={ActionType.block}
                        extraClasses={buttonAlignmentClasses}
                        title={labels.startOver}
                        data-ft-component="startOver"
                        onClick={(): void => {
                            actions.startOver()
                            hideModal()
                        }}
                    >
                        {Symbols.ArrowReset} {labels.startOver}
                    </Action>
                </div>
            </Modal>
        </>
    )
}
